import background from './background.png';
import phone from './phone.png';
import phoneBackground from './phone-background.png';
import phoneRewardBackground from './phone-reward-background.png';
import refreshIcon from './refresh.png';
import rewardIcon from './reward-icon.png';

const images = {
  background,
  phone,
  phoneBackground,
  phoneRewardBackground,
  refreshIcon,
  rewardIcon,
};

export default images;


// WEBPACK FOOTER //
// ./src/components/MobileDemo/images/index.js